import { render, staticRenderFns } from "./PatientTypeSelect.vue?vue&type=template&id=620146ee&"
import script from "./PatientTypeSelect.vue?vue&type=script&lang=js&"
export * from "./PatientTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./PatientTypeSelect.vue?vue&type=style&index=0&id=620146ee&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620146ee')) {
      api.createRecord('620146ee', component.options)
    } else {
      api.reload('620146ee', component.options)
    }
    module.hot.accept("./PatientTypeSelect.vue?vue&type=template&id=620146ee&", function () {
      api.rerender('620146ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/druginfo-manage/PatientTypeSelect.vue"
export default component.exports